var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.variazione
    ? _c(
        "v-card",
        [
          _c("v-card-subtitle", [_c("h2", [_vm._v("Variazioni correlate")])]),
          _c(
            "v-card-text",
            [
              _vm.variazione &&
              _vm.variazione.variazioniCorrelate.length > 0 &&
              !_vm.variazioniCorrelateTutteEliminate
                ? _c(
                    "v-layout",
                    { attrs: { row: "", wrap: "" } },
                    _vm._l(
                      _vm.variazione.variazioniCorrelate,
                      function (varCorrelata) {
                        return _c(
                          "v-flex",
                          {
                            key: varCorrelata.rigaDistinta.id,
                            attrs: { xs12: "" },
                          },
                          [
                            !varCorrelata.eliminataDaAs400
                              ? _c(
                                  "v-col",
                                  { staticClass: "col-dati" },
                                  [
                                    _c(
                                      "div",
                                      {
                                        class: {
                                          "deleted-field":
                                            _vm.isDeleted(varCorrelata),
                                        },
                                      },
                                      [
                                        _c("table", [
                                          _c("tr", [
                                            _c(
                                              "td",
                                              [
                                                _vm.isDeleted(_vm.variazione) ||
                                                _vm.isNew(_vm.variazione)
                                                  ? _c("v-switch", {
                                                      staticStyle: {
                                                        "margin-right": "10px",
                                                        "margin-left": "10px",
                                                      },
                                                      on: {
                                                        change: function (
                                                          $event
                                                        ) {
                                                          return _vm.cambiaStatoVariazione(
                                                            varCorrelata
                                                          )
                                                        },
                                                      },
                                                      model: {
                                                        value:
                                                          varCorrelata.mostraCorrelate,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            varCorrelata,
                                                            "mostraCorrelate",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "varCorrelata.mostraCorrelate",
                                                      },
                                                    })
                                                  : _vm._e(),
                                              ],
                                              1
                                            ),
                                            _c("td", [
                                              _c("div", {
                                                domProps: {
                                                  innerHTML: _vm._s(
                                                    _vm.descProvenienza(
                                                      varCorrelata
                                                    )
                                                  ),
                                                },
                                              }),
                                              !_vm.isNew(_vm.variazione)
                                                ? _c("div", [
                                                    _vm._v(" Colore: "),
                                                    _c("strong", [
                                                      _vm._v(
                                                        _vm._s(
                                                          varCorrelata
                                                            .rigaDistinta
                                                            .innerRigaDistinta
                                                            .coloreComponente
                                                        ) +
                                                          " (" +
                                                          _vm._s(
                                                            varCorrelata
                                                              .rigaDistinta
                                                              .innerRigaDistinta
                                                              .idColoreComponenteBgf
                                                          ) +
                                                          ")"
                                                      ),
                                                    ]),
                                                    _vm._v(
                                                      " , Unità di misura: "
                                                    ),
                                                    _c(
                                                      "strong",
                                                      {
                                                        attrs: {
                                                          "data-test":
                                                            "unita-di-misura",
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            varCorrelata
                                                              .rigaDistinta
                                                              .innerRigaDistinta
                                                              .unMisuraDiBa
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                                    _vm._v(" , id: "),
                                                    _c("em", [
                                                      _vm._v(
                                                        _vm._s(
                                                          varCorrelata
                                                            .rigaDistinta
                                                            .innerRigaDistinta
                                                            .idBgj
                                                        )
                                                      ),
                                                    ]),
                                                    _c("br"),
                                                    _vm._v(" Utilizzo: "),
                                                    _c("strong", [
                                                      _vm._v(
                                                        _vm._s(
                                                          varCorrelata
                                                            .rigaDistinta
                                                            .innerRigaDistinta
                                                            .utilizzo
                                                        )
                                                      ),
                                                    ]),
                                                  ])
                                                : _vm._e(),
                                            ]),
                                          ]),
                                        ]),
                                      ]
                                    ),
                                    !_vm.isDeleted(_vm.variazione) &&
                                    !_vm.isNotSelectedForNew(varCorrelata)
                                      ? _c("TabellaValori", {
                                          class: {
                                            "modified-field":
                                              _vm.isModified(varCorrelata),
                                            "deleted-field":
                                              _vm.isDeleted(varCorrelata),
                                          },
                                          attrs: { rigaDistinta: varCorrelata },
                                        })
                                      : _vm._e(),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ],
                          1
                        )
                      }
                    ),
                    1
                  )
                : _c(
                    "v-flex",
                    { attrs: { xs12: "" } },
                    [
                      _c(
                        "v-alert",
                        {
                          staticStyle: { margin: "auto" },
                          attrs: { type: "info", value: true },
                        },
                        [
                          _vm._v(
                            "Non ci sono righe correlate per questo componente."
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
            ],
            1
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }